// <auto-generated />
// ATENCAO: Arquivo auto-gerado pelo SetupController. Nao altere manualmente.

export const CLAUSULAS_COM_VISIB = {
  Interna: 'CLAUSULAS_COM_VISIB1',
  Externa: 'CLAUSULAS_COM_VISIB2',
  Ambas: 'CLAUSULAS_COM_VISIB3',
  // Mapa de sequencia (SequenciaLista) para lookup por codigo
  sequencia: {
    CLAUSULAS_COM_VISIB1: 1,
    CLAUSULAS_COM_VISIB2: 2,
    CLAUSULAS_COM_VISIB3: 3
  }
}
